module.exports = __webpack_public_path__ + "img/loading.f59a0e91.svg";